/**
 * Loading overlay shown while the FRONTEND measurement recompute runs — i.e.
 * after changing the measurement-point spacing (LeftToolbar). Visually identical to
 * the view-mode transition overlay (blurred backdrop + spinner) so the points
 * reloading reads the same as a view-mode switch.
 *
 * Driven by `workspace.frontendMeasurementCalculating`, which the in-Canvas
 * runner toggles around each recompute (see FrontendMeasurementRunner).
 */
import { useSelector } from 'react-redux';

import type { RootState } from '../../../store/store';
import { LoadingSpinner } from '../../loading/LoadingSpinner';

export const FrontendMeasurementLoadingOverlay = (): JSX.Element => {
  const calculating = useSelector((s: RootState) => s.workspace.frontendMeasurementCalculating);

  return (
    <div
      aria-hidden={!calculating}
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(16, 16, 16, 0.45)',
        backdropFilter: 'blur(14px) saturate(120%)',
        WebkitBackdropFilter: 'blur(14px) saturate(120%)',
        opacity: calculating ? 1 : 0,
        pointerEvents: calculating ? 'auto' : 'none',
        transition: 'opacity 200ms ease',
      }}
    >
      <LoadingSpinner size={56} />
    </div>
  );
};
